export default __webpack_public_path__ + "static/media/EV Fast Track Lane Factsheet.39d603ec.pdf";